import React, { createContext, useState, useContext } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, Box } from '@mui/material';
import { lightTheme, darkTheme } from './theme';
import './index.css'; 

const ThemeContext = createContext();

export const ThemeProviderComponent = ({ children }) => {
    const [theme, setTheme] = useState(lightTheme); // Default theme

    const toggleTheme = () => {
        setTheme(prevTheme =>
            prevTheme.palette.primary.main === '#007bff' ? darkTheme : lightTheme
        );
    };

    return (
        <ThemeContext.Provider value={{ toggleTheme }}>
            <ThemeProvider theme={theme}>
                <CssBaseline /> {/* Applies consistent global styles */}
                <Box
                    sx={{
                        backgroundColor: theme.palette.background.default,
                        color: theme.palette.text.primary,
                        minHeight: '100vh', // Ensure the container covers the full height of the viewport
                        overflowX: 'hidden', 
                        fontWeight: theme.typography.fontWeightRegular, // Applies the theme's regular font weight 
                    }}
                >
                    {children}
                </Box>

            </ThemeProvider>
        </ThemeContext.Provider>
    );
};

export const useTheme = () => useContext(ThemeContext);
